import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditableTable from "components/smea/Table/EditableTable";
import ConfirmationModal from "modals/smea/miscellaneous/ConfirmationModal";
import useAxiosPrivate from "contexts/interceptors/axios";

export default function GradeTable({
  data,
  setSelectedData,
  loadingState,
  updateTableFunction,
}) {
  const axiosPrivate = useAxiosPrivate();
  const [selectedGrade, setSelectedGrade] = useState();
  const [rowToDelete, setRowToDelete] = useState();

  const [open, setOpen] = useState(false);
  const [promptResponse, setPromptResponse] = useState(null);
  const [submit, setSubmit] = useState(false);
  const [submitKind, setSubmitKind] = useState("");
  const [promptDesc, setPromptDesc] = useState("");

  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState("");

  setSelectedData(selectedGrade);

  useEffect(() => {
    if (rowToDelete) {
      setPromptDesc("Are you sure you want to delete this data?");
      setSubmitKind("delete");
      setOpen(true);
    }
  }, [rowToDelete]);

  useEffect(() => {
    if (!open && submit && promptResponse && rowToDelete) {
      setLoading(true);

      axiosPrivate
        .delete(`/level/deleteLevel/${rowToDelete[0]?.id}`)
        .then(() => {
          alert("Grade Level deleted successfully");
          setRowToDelete(null);
          setSubmit(false);
          updateTableFunction();
        })
        .catch((err) => {
          alert(err?.message);
          setRowToDelete(null);
          setSubmit(false);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [submit, promptResponse]);

  const columns = [
    // { field: "id", headerName: "ID", width: 70 },
    {
      field: "levelGrade",
      headerName: "Level Grade",
      width: 150,
    },
  ];

  return (
    <Box sx={{ width: "100%" }}>
      <ConfirmationModal
        open={open}
        handleClose={() => setOpen(false)}
        setPromptResponse={setPromptResponse}
        setSubmit={setSubmit}
        submitKind={submitKind}
        promptDesc={promptDesc}
      />
      <EditableTable
        data={data}
        columns={columns}
        checkbox
        loading={loadingState || loading}
        singleSelect
        setSelectedData={setSelectedGrade}
        rowToDelete={setRowToDelete}
        height="60vh"
        remove
      />
    </Box>
  );
}
